import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import {INVOICE_PRICE_DEVIATION} from '../../constants/constants'
import _ from 'lodash';

const Box = (props) => {
  function handleEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      var inputs = document.querySelectorAll('[tabIndex="' + (e.target.tabIndex) + '"]');
      var currentIndex = _.findIndex(inputs, input => input === e.target);
      if (currentIndex > -1 && currentIndex + 1 < inputs.length) {
        inputs[currentIndex + 1].select();
      } else if (inputs.length > 0) {
        inputs[0].select();
      }
    }
  }


  return(
    <tr>
      {props.showLines ? <td className="hidden-xs-down">{props.index+1}</td> : null}
      <td>{props.box.item}</td>
      <td className="hidden-xs-down">{props.box.brand}</td>
      <td className="hidden-xs-down"><b>{props.box.station}</b></td>
      <td className="hidden-xs-down"><b>{props.box.category}</b></td>
      <td className="row">
        <span className="col-sm-8 col-8">
          <input onKeyDown={handleEnter} type="number" className="form-control" value={props.box.weight} onChange={(weight) => props.onWeightBoxesChange(weight,props.index)} tabIndex="1"/>
          {(props.errors.indexOf('weight-Box-'.concat(String(props.index))) !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter a positive value.</em> : <em></em>}
        </span>
        <span className="col-sm-4 col-xm-4 pl-0">
          <span className="badge badge-pill badge-info">{props.box.measure_unit}</span>
        </span>
      </td>
      <td>
        <input type="number" className="form-control" value={props.box.pieces} onChange={(pieces) => props.onPiecesBoxesChange(pieces,props.index)} tabIndex="2"/>
        {(props.errors.indexOf('numberItems-Box-'.concat(String(props.index))) !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter a positive integer value.</em> : <em></em>}
      </td>
      <td>
        <div className={`input-group ${props.warningPrice ? 'has-warning':''}`}>
          <div className="input-group-addon">$</div>
          <input className="form-control" type="number" value={props.box.price} onChange={(price) => props.onPriceBoxesChange(price,props.index)} tabIndex="3"/>
        </div>
        {(props.errors.indexOf('price-Box-'.concat(String(props.index))) !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter a positive value.</em> : <em></em>}
      </td>
      <td className="d-flex">
          {props.editBox ?
            <a href="#" className="btn btn-primary" onClick={()=>props.editBox(props.index)}><i className="fa fa-pencil"></i></a>
          :
            null
          }
          <span className="btn btn-danger" onClick={()=>props.deleteBox(props.index)}><i className="fa fa-trash"></i></span>
      </td>
    </tr>
  )
}

const BoxFinished = (props) => {
  return(
    <tr>
      {props.showLines ? <td className="hidden-xs-down">{props.index+1}</td> : null}
      <td>{props.box.item}</td>
      {props.box.id ?
        <td>
          <NavLink to={`/inventory/${props.box.id}/`}>
            {props.box.id}
          </NavLink>
        </td>
      :
        null
      }
      <td className="hidden-xs-down">{props.box.brand}</td>
      <td className="hidden-xs-down"><b>{props.box.station}</b></td>
      <td className="hidden-xs-down"><b>{props.box.category}</b></td>
      <td><b>{props.box.weight}</b>
        <span className="ml-05 badge badge-pill badge-info">{props.box.measure_unit}</span>
      </td>
      <td className="hidden-xxs-down"><b>{props.box.pieces}</b></td>
      <td><b>{props.box.price}</b></td>
    </tr>
  )
}

export default class Boxes extends Component {
  render() {
    let actions = !this.props.isAlreadyFinished && <th>Actions</th>;

    if (this.props.boxes.length === 0) {
      return (
        <div className="empty-table-message">
          <span>No items yet.</span>
        </div>
      );
    } else {
      return(
        <div className="row">
          <div className="col">
          <table className="table table-striped table-hover">
            <thead className="thead-inverse">
              <tr>
                {this.props.showLines && !this.props.isAlreadyFinished ? <th className="hidden-xs-down">-</th> : null}
                <th>Item</th>
                {this.props.isAlreadyFinished ? <th>Id</th> : null}
                <th className="hidden-xs-down">Manufacturer</th>
                <th className="hidden-xs-down">Destination</th>
                <th className="hidden-xs-down">Category</th>
                <th>Qty</th>
                <th className="hidden-xxs-down">Pieces</th>
                <th>Price</th>
                {actions}
              </tr>
            </thead>
            <tbody>
            {this.props.boxes.map((box, idx) => {
              if(this.props.isAlreadyFinished){
                return(
                  <BoxFinished box={box} key={idx} index={idx} showLines={false}/>
                );
              } else {
                return(
                  <Box
                    box={box}
                    key={idx}
                    index={idx}
                    onWeightBoxesChange={this.props.onWeightBoxesChange}
                    onPiecesBoxesChange={this.props.onPiecesBoxesChange}
                    onPriceBoxesChange={this.props.onPriceBoxesChange}
                    deleteBox={this.props.deleteBox}
                    editBox={this.props.editBox}
                    showLines={this.props.showLines}
                    errors={this.props.errors}
                    warningPrice={this.props.overAveragePriceWarning && box.item_average_invoice_price > 0 && Math.abs(box.price - box.item_average_invoice_price) > box.item_average_invoice_price * INVOICE_PRICE_DEVIATION}
                  />
                );
              }
            })}
            </tbody>
          </table>
        </div>
      </div>
      )
    }
  }
}
